var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"map",staticClass:"map-container",attrs:{"id":"map"}},[_vm._v("\n    Carga una dirección para ver el mapa.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }